import CostCenterEdit from "CostCenter/edit";
import CostCenterList from "CostCenter/list";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const costCenterRoute: RouteObject = {
  path: "costcenter",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: CostCenterList,
  }, {
    path: ":key/edit",
    loader: () => viewModel,
    Component: CostCenterEdit,
  }]
};